import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListMerchantsAction = "LIST_MERCHANTS";
const ListAcquirersAction = "LIST_ACQUIRERS";
const ListConfirmPaymentsAction = "LIST_CONFIRM_PAYMENTS";
const Waiting = "WAITING";

const initialState = {
    list: [],
    listConfirm: [],
    nowWainting: false,
};
export const actionCreators = {
    /**
     * 加盟店一覧を取得します。
     */
    listMerchants: (token) => async (dispatch) => {
        const routeurl = `api/user/merchants/list`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const list = await response.json();
                dispatch({ type: ListMerchantsAction, list: list });
                return list;
            } else {
                throw new Error('加盟店一覧の取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 代表加盟店一覧を取得
    */
    listAcquirers: (token) => async (dispatch) => {
        const routeurl = `api/user/merchants/list_acquirer`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const list = resp.result;
                    dispatch({ type: ListAcquirersAction, list: list });
                    return list;
                } else {
                    throw new Error(resp.error_message || '代表加盟店一覧取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 精算書確認情報リストを取得を取得します。
     */
    listConfirmPayment: (token, merchantId, nengetsu) => async (dispatch) => {
        const routeurl = `api/user/confirmPayments/list`;

        var param = `?merchantId=${merchantId}&nengetsu=${nengetsu}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const listConfirm = await resp.result;
                    dispatch({ type: ListConfirmPaymentsAction, listConfirm: listConfirm });
                    return listConfirm;
                } else {
                    throw new Error(resp.error_message || '精算書確認情報リストの取得に失敗しました。');
                }
            } else {
                throw new Error('精算書確認情報リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 精算書確認情報リストを初期化します。
     */
    initListConfirmPayment: () => async (dispatch) => {
        dispatch({ type: ListConfirmPaymentsAction, listConfirm: [], nowWainting: false });
    },

    /**
     * 精算書 PDF をダウンロードします。
     * @param {string} nengetsu 検索対象年月（yyyy/mm/01）
     * @returns {Promise<byte[]|null>} base64 エンコードされた PDF バイナリ
     */
    downloadPdf: (token, merchantId, seq, nengetsu) => async (dispatch) => {
        const routeurl = `api/user/confirmPayments/pdf`;
        const param = `?merchantId=${merchantId}&seq=${seq}&nengetsu=${nengetsu}`;

        dispatch({ type: Waiting, nowWainting: true });
        try {
            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            });

            if (response.status === 200) {
                const resp = await response.json();
                if (resp.error_message != null) {
                    throw new Error(resp.error_message || 'PDF の取得に失敗しました。');
                }
                return resp.result;
            } else {
                throw new Error('PDF の取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 精算書 CSV をダウンロードします。
     * @param {number} csvType 1:日別 2:取引明細 3:ポイント明細
     * @param {string} nengetsu 検索対象年月（yyyy/mm/01）
     * @returns {Promise<byte[]|null>} base64 エンコードされた CSV バイナリ
     */
    downloadCsv: (token, merchantId, seq, csvType, nengetsu) => async (dispatch) => {
        const routeurl = `api/user/confirmPayments/csv`;
        const param = `?merchantId=${merchantId}&seq=${seq}&csvType=${csvType}&nengetsu=${nengetsu}`;

        dispatch({ type: Waiting, nowWainting: true });
        try {
            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            });

            if (response.status === 200) {
                const resp = await response.json();
                if (resp.error_message != null) {
                    throw new Error(resp.error_message || 'CSV の取得に失敗しました。');
                }
                return resp.result;
            } else {
                throw new Error('CSV の取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    // 加盟店リスト
    if (action.type === ListMerchantsAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    // 代表加盟店リスト
    if (action.type === ListAcquirersAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    // 精算書確認情報リスト
    if (action.type === ListConfirmPaymentsAction) {
        return {
            ...state,
            listConfirm: action.listConfirm,
            nowWainting: action.nowWainting
        };
    }
    return state;
}